import {styled} from "@mui/material";

export const ShipmentPriceContainer = styled('div')(({theme}) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: '0.5rem 0.5rem',
    borderRadius: '0.5rem',
    backgroundColor: theme.barekam.background
}));

export const ExistingOrderData = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: '0.5rem 0.5rem',
    borderRadius: '0.5rem',
    border: '1px solid #CFCFE0',
}));

export const UserNotFoundContainer = styled(ExistingOrderData)(() => ({
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    border: '1px solid #DA1944',
    color: '#DA1944',
}));

export const UserFoundContainer = styled(UserNotFoundContainer)(() => ({
    color: '#087E38',
    border: '1px solid #087E38',
}));
